EVERFLOW_TRACKING_QUERY_VARS